import React from 'react';
import { Hero } from './components/Hero';
import { SystemSection } from './components/SystemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusSection } from './components/BonusSection';
import { TransformationSection } from './components/TransformationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-ink font-sans text-ivory" data-id="element-0" data-mp="28ufp6dtutik4">
      <Hero data-id="element-1" data-mp="28suumo7jhzm9" />
      <main data-id="element-2" data-mp="28sl511qepuh3">
        <SystemSection data-id="element-3" data-mp="28s2xva27hvue" />
        <VolumesSection data-id="element-4" data-mp="23vkuadim43jn" />
        <BonusSection data-id="element-5" data-mp="23u9ueosaffxt" />
        <TransformationSection data-id="element-6" data-mp="23ut97wmn5o7m" />
        <TestimonialsSection data-id="element-7" data-mp="3ijxq4swlw4ky" />
        <OfferSection data-id="element-8" data-mp="3ikqyfyb7r257" />
        <FaqSection data-id="element-9" data-mp="3ij61k21ff746" />
        <FinalCtaSection data-id="element-10" data-mp="3ihv2gfixenje" />
      </main>
      <SiteFooter data-id="element-11" data-mp="3ml1419v3fqjj" />
      <PurchaseNotifications data-id="element-12" data-mp="3mkhm3t5g125i" />
    </div>;
}